import styled from 'styled-components'
import {
	ArrowDownward as ArrowDownwardIcon,
	FilterList as FilterListIcon,
} from "@material-ui/icons";
import { Button, FormControlLabel } from "@material-ui/core";

import { MaterialSelector } from "components/Selector";
import { CrossButtonDark } from "components/Buttons/CrossButton";
import { pageContainerStyles } from '../../themes/layout';

export const Container = styled.div`
	${pageContainerStyles}
	padding-top: 1rem;
	padding-bottom: 1rem;
	background-color: #fff;
	height: 100%;
	width: 100%;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	overflow-x: hidden;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
`

export const TitleContentContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
  padding: 0 0.5rem;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 0.5rem 0.5rem 0;
  margin-bottom: 0.5rem;
`;

export const BackButton = styled.button`
  position: absolute;
  left: 0.5rem;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  background: transparent;
  border: 1px solid #E0E0E0;
  border-radius: 8px;
  color: var(--primary-blue, #0B4598);
  font-family: var(--fontMain, Poppins), sans-serif;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  
  svg {
    font-size: 1.25rem;
  }
  
  &:hover {
    background: rgba(11, 69, 152, 0.04);
    border-color: var(--primary-blue, #0B4598);
  }
  
  &:active {
    transform: scale(0.98);
  }
`;

export const Title = styled.div`
  font-size: 1.25rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.87);
  text-align: center;
  width: 100%;
  /* T2-6715: 7rem side padding left a tiny content box on Android so
     "Permanent Job Board" wrapped word-by-word. Keep one line. */
  padding: 0 1rem;
  box-sizing: border-box;
  white-space: nowrap;
`;

export const StyledArrowDownwardIcon = styled(ArrowDownwardIcon)`
	height: 20px !important;
	color: #0B4598FF;
	margin-right: 0.5rem;
`

export const StyledFilterListIcon = styled(FilterListIcon)`
	height: 20px !important;
	color: #0B4598FF;
	margin-right: 0.5rem;
`

export const TitleContentButton = styled.div`
	display: flex;
	align-items: center;
	font-size: 0.875rem;
	font-weight: 600;
	color: #0B4598FF;
	cursor: pointer;
`;

export const PopupContainerBase = styled.div`
  border-radius: 8px;
  background: white;
`

export const PopupContainer = styled(PopupContainerBase)`
  padding: 1.5rem 1rem;
  border-radius: 8px;
  background: white;
`

export const PopupTitle = styled.div`
  font-size: 1.2rem;
  line-height: 1.4;
  font-weight: 600;
`

export const PopupTitlesContainer = styled.div`
	padding: 0 1rem;
	margin-bottom: 1.75rem;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	position: relative;
	text-align: center;
`

export const SortingOptionButton = styled.div`
	color: rgba(0, 0, 0, 0.87);
	font-size: 1rem;
	width: 100%;
	padding: 0.75rem 1rem;
	cursor: pointer;
`;

export const StyledCrossButtonDark = styled(CrossButtonDark)`
  top: 0;
  bottom: 0;
  right: 0;
  position: relative;
`

export const PopupSectionContainer = styled.div`
	margin: 1.5rem 0;
	padding: 0 1rem;
	font-size: 16px;
`

export const SubmitButtonContainer = styled.div`
	margin: 3.5rem 0 1.5rem;
`

export const MultipleCheckboxesContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0 1rem;
  margin-top: 0.5rem;
`

export const StyledFormControlLabel = styled(FormControlLabel)`
  width: 40%;
`

export const CheckboxLabel = styled.div`
  font-size: 14px;
`

export const StyledMaterialSelector = styled(MaterialSelector)`
  padding-right: 2rem !important;
`

export const ResetFiltersButton = styled(Button)`
	text-transform: unset;
	font-weight: 600;
	font-size: 0.875rem;
	border-radius: 8px;
`

// ---------------- Empty State ----------------

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 4rem 2rem;
  text-align: center;
`;

export const EmptyStateText = styled.div`
  font-size: 1.5rem;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.87);
  margin-bottom: 0.75rem;
`;

export const EmptyStateSubtext = styled.div`
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.5);
  max-width: 280px;
  line-height: 1.5;
`;

// ---------------- Featured Strip (Job Board) ----------------

export const FeaturedStrip = styled.div`
	margin: 12px 0;
`

export const FeaturedStripTitle = styled.div`
	font-weight: 700;
	margin-bottom: 8px;
	color: var(--primary-blue, #0B4598);
`

export const FeaturedStripScroller = styled.div`
	display: flex;
	overflow-x: auto;
	gap: 12px;
	padding-bottom: 8px;
`

export const FeaturedCard = styled.div<{ $pinned?: boolean }>`
	min-width: 300px;
	flex: 0 0 auto;
	border: ${({ $pinned }) => $pinned ? '3px solid rgba(11,69,152,0.35)' : '2px solid var(--primary-blue, #0B4598)'};
	background: ${({ $pinned }) => $pinned ? '#ffffff' : 'rgba(11,69,152,0.04)'};
	border-radius: 10px;
	padding: 12px 14px;
	box-shadow: 0 1px 3px rgba(0,0,0,0.08);
`

export const FeaturedCardTitle = styled.div`
	font-weight: 600;
	margin-bottom: 4px;
`

export const FeaturedCardSub = styled.div`
	font-size: 12px;
	opacity: 0.85;
`

export const NewOpportunityChip = styled.div`
	margin-top: 6px;
	font-size: 12px;
	font-weight: 700;
	color: var(--accent-gold, #a16207);
`;

